module.exports = __webpack_public_path__ + "img/19.01a1800e.png";